// Vollea — Splash / Landing screen with full-bleed brand artwork
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Btn } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP } from "../lib/theme";

// Hero splash artwork supplied by brand (contains wordmark + tagline + ball)
const HERO_IMG = "https://customer-assets.emergentagent.com/job_vollea-responsive/artifacts/x0g43gci_E6CA5FD0-5320-421D-B9DB-6BBD27944FDD.jpeg";

export default function Landing() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/public").then(setStats).catch(() => {});
  }, []);

  const proof = (() => {
    if (!stats) return null;
    if ((stats.players || 0) >= 1) return `${stats.players} player${stats.players === 1 ? "" : "s"} already competing`;
    if ((stats.leagues || 0) >= 1) return `${stats.leagues} league${stats.leagues === 1 ? "" : "s"} live in the beta`;
    if ((stats.clubs || 0) >= 1) return `${stats.clubs} club${stats.clubs === 1 ? "" : "s"} on Vollea`;
    return "Closed beta — by invitation";
  })();

  return (
    <div
      style={{
        minHeight: "100vh", background: C.bg, display: "flex", flexDirection: "column",
        padding: SP.lg,
      }}
    >
      <div
        style={{
          flex: 1, display: "flex", alignItems: "flex-end", justifyContent: "center",
          paddingBottom: SP.lg, minHeight: 0,
        }}
      >
        <img
          src={HERO_IMG}
          alt="Vollea LeaguePoint — The home of competitive padel"
          data-testid="landing-hero-image"
          style={{
            display: "block", width: "100%", maxHeight: "100%",
            objectFit: "contain", objectPosition: "bottom center",
          }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: SP.md, paddingBottom: SP.md, flexShrink: 0 }}>
        <Btn label="Create account" testid="landing-create-account" onClick={() => navigate("/register")} />
        <Btn label="Log in" variant="dark" testid="landing-login" onClick={() => navigate("/login")} />
        {proof && (
          <div
            data-testid="landing-social-proof"
            style={{
              textAlign: "center",
              fontSize: 11,
              letterSpacing: 1.4,
              fontWeight: 600,
              textTransform: "uppercase",
              color: C.textMuted,
              marginTop: 4,
            }}
          >
            <span style={{ color: C.lime }}>●</span>{" "}
            <span data-testid="landing-social-proof-text">{proof}</span>
          </div>
        )}
      </div>
    </div>
  );
}
